<template>
    <div>
        <el-card>
            <div slot="header" class="flex flex-between flex-v-center">
                <h4>{{ $t('我的作业') }}</h4>
            </div>
            <div style="padding: 0 10px;" class="margin-t">
                <el-tabs v-model="status" @tab-click="query()">
                    <el-tab-pane :label="$t('未作答') + '(' + counts[0] + ')'" name="0"></el-tab-pane>
                    <el-tab-pane :label="$t('待批改') + '(' + counts[1] + ')'" name="1"></el-tab-pane>
                    <el-tab-pane :label="$t('已批改') + '(' + counts[2] + ')'" name="2"></el-tab-pane>
                </el-tabs>
            </div>
            <div v-loading="loading == 'list'" class="margin-t" v-if="list.length > 0">
                <div v-for="(item, index1) in list" :key="index1" @click="to1(item)"
                    :class="{ 'bb': index1 < list.length - 1 }" class="mock-item on">
                    <div class="flex flex-between flex-v-center" style="height:100%">

                        <div>
                            <h5>
                                <el-tag class="margin-r">{{ item.clazz_name }}</el-tag>
                                {{ item.title }}
                            </h5>


                            <div class="flex flex-v-center margin-t">

                                <div style="font-size: 12px;gap:" class="flex flex-v-center">{{ $t('布置老师')
                                }}： <el-avatar class="margin-r" size="small" :src="item.teacher.avatar"></el-avatar>
                                    {{
                                        item.teacher.name }}</div>

                                <div style="font-size: 12px;margin-left:40px;">{{ $t('布置时间')
                                }}：{{
                                        item.created_at }}</div>

                                <div style="font-size: 12px;margin-left:40px;">{{ $t('过期时间')
                                }}：{{
                                        item.expiry_time }}</div>

                            </div>
                        </div>
                        <div class="flex flex-v-center">
                            <h5 v-if="item.status == 0">【{{ $t('未作答') }}】</h5>
                            <h5 v-else-if="item.status == 1">【{{ $t('待批改') }}】</h5>
                            <h5 v-else-if="item.status == 2">【{{ $t('已批改') }}】</h5>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <el-empty v-loading="loading == 'list'" v-else></el-empty>
        </el-card>



        <el-dialog :fullscreen="record.status > 0" v-if="record" custom-class="br" :visible.sync="dalogVisible"
            :close-on-click-modal="false" :show-close="false" width="50%" center>
            <h4 slot="title">{{ workItem.title }}</h4>

            <el-row :gutter="40">
                <el-col :span="record.status == 0 ? 24 : 12">
                    <el-card shadow="never">
                        <div slot="header" class="flex flex-v-center flex-between">
                            <h3>{{ $t('我的作答') }}</h3>
                            <span v-if="record.user_time" class="color-primary">{{ $t('提交时间') }}：{{ record.user_time
                            }}</span>
                        </div>

                        <div>{{ record.work.content }}</div>
                        <div v-for="(item1, i) in record.work.attachment" :key="i">
                            <el-divider></el-divider>
                            <div class="flex flex-between flex-v-center">
                                <audio controls v-if="item1.type == 'audio'" :src="$host + item1.url"></audio>
                                <el-image :preview-src-list="[$host + item1.url]" v-else-if="item1.type == 'image'"
                                    style="height: 100px;width: 200px;" fit="cover" :src="$host + item1.url"></el-image>
                                <el-link v-else-if="item1.type == 'file'">{{ item1.url.split('/').pop() }}</el-link>

                                <div class="flex flex-v-center">
                                    <el-tooltip :content="$t('下载')">
                                        <el-button @click="remove_attachment(i)" style="font-size: 25px;" type="text"
                                            icon="el-icon-download"></el-button>
                                    </el-tooltip>
                                </div>
                            </div>

                        </div>
                        <el-divider></el-divider>
                        <el-form ref="form" label-position="top" :model="form" label-width="80px">

                            <el-form-item prop="content">
                                <template slot="label">
                                    <span>{{ $t('作答内容') }}</span>
                                    <el-switch v-if="record.status == 0" style="position:relative;bottom:1px;left:40px"
                                        v-model="audio" :inactive-text="$t('文本')" :active-text="$t('录音')"></el-switch>
                                </template>

                                <template v-if="record.status == 0">
                                    <div v-if="audio" class="flex flex-v-center margin-t">
                                        <audio-recorder @content="setContent" :time_limit="120"
                                            :submittable="false"></audio-recorder>
                                    </div>
                                    <el-input v-else :readonly="record.status > 0" type="textarea" :rows="6"
                                        :placeholder="$t('请输入作业内容')" v-model="form.text">
                                    </el-input>
                                </template>
                                <template v-else>
                                    <audio controls v-if="record.content.endsWith('.wav')"
                                        :src="$host + record.content"></audio>
                                    <el-input v-else readonly type="textarea" :rows="6" :placeholder="$t('请输入作业内容')"
                                        v-model="record.content">
                                    </el-input>
                                </template>



                            </el-form-item>
                        </el-form>
                    </el-card>

                </el-col>

                <el-col :span="12" v-if="record.status > 0">
                    <el-card shadow="never">
                        <div slot="header" class="flex flex-v-center flex-between">
                            <h3>{{ $t('老师批改') }}</h3>
                            <span class="color-primary" v-if="record.status == 2">{{ record.teacher_time }}</span>
                        </div>
                        <el-empty :description="$t('暂无老师批改结果')" v-if="record.status == 1"></el-empty>
                        <el-form v-else ref="form" label-position="top" :model="form" label-width="80px">
                            <el-form-item prop="title">
                                <el-switch disabled v-model="record.result.pass" :inactive-text="$t('不达标')"
                                    :active-text="$t('达标')"></el-switch>
                            </el-form-item>

                            <el-form-item prop="content" :label="$t('评价内容')">
                                <el-input type="textarea" readonly :rows="6" :placeholder="$t('请输入评价内容')"
                                    v-model="record.result.content">
                                </el-input>

                                <div v-for="(item, i) in record.result.attachment" :key="i">
                                    <el-divider></el-divider>
                                    <div class="flex flex-between flex-v-center">
                                        <audio controls v-if="item.type == 'audio'" :src="$host + item.url"></audio>
                                        <el-image :preview-src-list="[$host + item.url]"
                                            v-else-if="item.type == 'image'" style="height: 100px;width: 200px;"
                                            fit="cover" :src="$host + item.url"></el-image>
                                        <el-link v-else-if="item.type == 'file'">{{ item.url.split('/').pop()
                                            }}</el-link>

                                        <div class="flex flex-v-center">
                                            <el-tooltip :content="$t('下载')">
                                                <el-button @click="remove_attachment(i)" style="font-size: 25px;"
                                                    type="text" icon="el-icon-download"></el-button>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </el-col>
            </el-row>
            <span class="dialog-footer center" slot="footer">
                <el-button icon="el-icon-close" @click="dalogVisible = false">{{ $t('关 闭') }}</el-button>

                <el-button icon="el-icon-check" class="margin-l" type="primary" v-if="record.status == 0"
                    @click="submit()" :disabled="(audio && !form.file) || (!audio && !form.text)">{{
                        $t('提交作答') }}</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import AudioRecorder from '../../components/AudioRecorder.vue';
export default {
    components: { AudioRecorder },
    data() {
        return {
            counts: [0, 0, 0],
            audio: false,
            status: '0',
            list: [],
            workItem: null,
            record: null,
            form: { text: null, file: null },
            dalogVisible: false,
            loading: null,
        };
    },

    computed: {

    },



    created() {
        this.get_counts()
        this.query();
    },

    methods: {
        submit() {
            let formData = new FormData();
            if (this.audio) {
                formData.append("file", this.form.file);
            } else {
                formData.append("text", this.form.text);
            }
            formData.append("id", this.record.id);
            this.$http.post("/api/homework/record", formData, {
                timeout: 60000,
                headers: {
                    'Content-type': 'multipart/form-data'
                }
            }).then(() => {
                this.get_counts()
                this.query()
                this.dalogVisible = false
            })
        },
        setContent(e) {
            this.form.file = e
        },

        get_counts() {
            this.$http.post("/api/homework/counts").then((counts) => {
                this.counts = counts
            })
        },
        query() {
            this.loading = 'list'

            this.$http.post("/api/homework/list", { status: this.status }).then((list) => {
                this.list = list;
                this.loading = null
            })
        },

        to1(item) {
            this.workItem = item;
            this.$http.post("/api/homework/record/info", { id: item.id }).then((record) => {
                this.record = record;
                this.dalogVisible = true;
            })
        },

        remove(item) {
            this.$confirm('', this.$t('确认删除此模考记录') + '?', {
                center: true,
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
                type: 'primary'
            }).then(() => {
                this.$http.post("/api/mock/record/remove", { id: item.id }).then(() => {
                    this.query();
                })
            });
        },

    },
};
</script>

<style scoped>
.mock-item {
    cursor: pointer;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
}

.mock-item.bb {
    margin-bottom: 15px;
}

.mock-item:hover,
.mock-item.on {
    border: 1px solid #e6a13c;
    color: #e6a13c;
}
</style>
